import ListItem from "@mui/material/ListItem";
import IconButton from "@mui/material/IconButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import DeleteIcon from "@mui/icons-material/Delete";
import React, { useState } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import * as api from "../../api";
import { Divider, Typography, ListItemButton } from "@mui/material";
import { useNavigate } from "react-router-dom";
import EditIcon from "@mui/icons-material/Edit";
import { useErrorMessage } from "@poseidon/ui/app/toasts/useErrorMessage";
import { useToastMessage } from "@poseidon/ui/app/toasts/useToastMessage";
import { useBaseRoutePathContext } from "@poseidon/utils/base-route-path";

export default function AddressListItem({ address, sailorId, setDeleted }) {
  const baseRoutePath = useBaseRoutePathContext();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { setError } = useErrorMessage();
  const { setToast } = useToastMessage();

  const deleteAddress = async (address) => {
    setLoading(true);
    const response = await api.removeAddress(address);

    if (response instanceof Error) {
      setError(response.message);
    }

    setDeleted();
    setToast("Address deleted");
    setLoading(false);
  };

  return (
    <>
      <ListItem
        secondaryAction={
          <IconButton
            edge="end"
            aria-label="delete"
            onClick={() => deleteAddress(address)}
          >
            {loading ? <CircularProgress size={28} /> : <DeleteIcon />}
          </IconButton>
        }
      >
        <ListItemButton
          onClick={() =>
            navigate(
              `${baseRoutePath.path}/sailors/${sailorId}/addresses/${address.id}`
            )
          }
        >
          <ListItemIcon>
            <EditIcon />
          </ListItemIcon>
          <ListItemText
            primary={`${address.houseNumber ?? address.houseName} ${
              address.street_1
            }`}
            secondary={
              <>
                <Typography
                  sx={{ display: "inline" }}
                  component="span"
                  variant="caption"
                  color="text.primary"
                >
                  {address.postcode}
                </Typography>
                <br />
                <Typography
                  sx={{ display: "inline", textAlign: "right" }}
                  component="span"
                  variant="caption"
                  color="text.secondary"
                >
                  {address.from.toLocaleDateString("en-GB")} -{" "}
                  {address.current
                    ? "Now"
                    : address.to?.toLocaleDateString("en-GB")}
                </Typography>
              </>
            }
          />
        </ListItemButton>
      </ListItem>
      <Divider variant="inset" component="li" />
    </>
  );
}
